// // src/pages/SupportPage.js
// import React from 'react';

// function SupportPage() {
//   return (
//     <div className="container" style={{ padding: '40px 20px' }}>
//       <h1>Support</h1>
//       <p>This is the support page content.</p>
//       {/* Add your support page content here */}
//     </div>
//   );
// }

// export default SupportPage;

import React from "react";
import "../styles/SupportPage.css";

export default function SupportPage() {
  const SUPPORT_EMAIL = "support@gimmeresume.ai";

  const mailto = (subject, body) => {
    return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };
  

  const contactHref = mailto(
    "Support Request",
    [
      "Hi Support Team,",
      "",
      "I need help with:",
      "",
      "Email used at checkout:",
      "Stripe receipt link (if available):",
      "What I was trying to do:",
      "What happened instead:",
      "Error message (if any):",
      "Browser + device:",
      "",
      "Thanks!",
    ].join("\n")
  );

  const billingHref = mailto(
    "Billing Help — ",
    [
      "Hi Support Team,",
      "",
      "Billing issue:",
      "",
      "Email used at checkout:",
      "Stripe receipt link (recommended):",
      "Approx purchase date/time:",
      "Last 4 digits of card (if known):",
      "",
      "What happened:",
      "",
      "Thanks!",
    ].join("\n")
  );

  const refundHref = mailto(
    "Refund Review — ",
    [
      "Hi Support Team,",
      "",
      "I’m requesting a refund review (special consideration) within 7 days of purchase.",
      "",
      "Email used at checkout:",
      "Stripe receipt link (recommended):",
      "Purchase date:",
      "",
      "Reason for request:",
      "",
      "Screenshots / error details (if applicable):",
      "",
      "Thanks!",
    ].join("\n")
  );

  const bugHref = mailto(
    "Bug Report — ",
    [
      "Hi Support Team,",
      "",
      "Bug summary:",
      "",
      "Steps to reproduce:",
      "1)",
      "2)",
      "3)",
      "",
      "Expected result:",
      "Actual result:",
      "",
      "Browser + device:",
      "Screenshot/screen recording link (if available):",
      "",
      "Thanks!",
    ].join("\n")
  );

  return (
    <div className="supportPage">
      <div className="supportHero">
        <h1 className="supportTitle">Support</h1>
        <p className="supportSubtitle">
          Need help with your purchase or having trouble using the app? We’re here.
        </p>

        <div className="supportCtas">
          <a className="supportBtn primary" href={contactHref}>
            Email Support
          </a>
          <a className="supportBtn" href={billingHref}>
            Billing Help
          </a>
          <a className="supportBtn" href={refundHref}>
            Refund Review
          </a>
        </div>

        <div className="supportMeta">
          <span>Response time: typically within 1 business day</span>
          <span>Payments processed via Stripe (receipt link helps us locate your order)</span>
        </div>
      </div>

      <div className="supportGrid">
        <section className="supportCard">
          <h2>Contact Support</h2>
          <p>
            Email us at <strong>{SUPPORT_EMAIL}</strong>.
          </p>
          <p className="muted">
            Include the email used at checkout, what you were trying to do, any error
            message, screenshots (if relevant), and your Stripe receipt link if you have it.
          </p>
          <a className="supportLink" href={contactHref}>
            Start a support email →
          </a>
        </section>

        <section className="supportCard">
          <h2>Billing Help</h2>
          <p className="muted">
            For receipt requests, duplicate charges, payment issues, or access not delivered.
          </p>
          <ul>
            <li>Receipt / invoice request</li>
            <li>Duplicate charge</li>
            <li>Charged but didn’t receive access</li>
            <li>Payment confirmed but app didn’t update</li>
          </ul>
          <a className="supportLink" href={billingHref}>
            Email billing help →
          </a>
        </section>

        <section className="supportCard">
          <h2>Refund Requests (Special Consideration)</h2>
          <p className="muted">
            All purchases are one-time payments. We generally do not offer refunds.
            We will review requests made within <strong>7 days</strong> in special circumstances:
          </p>
          <ul>
            <li>Charged more than once for the same purchase</li>
            <li>Charged but did not receive access/deliverables due to an unresolved issue</li>
            <li>Product unavailable/unusable for an extended period due to a verified outage</li>
          </ul>
          <p className="muted">
            If approved, refunds typically appear within 5–10 business days depending on your bank.
          </p>
          <a className="supportLink" href={refundHref}>
            Request a refund review →
          </a>
        </section>

        <section className="supportCard">
          <h2>Report a Bug</h2>
          <p className="muted">
            Found something that isn’t working? Send steps to reproduce and a screenshot/screen recording if possible.
          </p>
          <a className="supportLink" href={bugHref}>
            Report a bug →
          </a>
        </section>

        <section className="supportCard note">
          <h2>Security & Privacy Note</h2>
          <p className="muted">
            Please don’t email sensitive personal information (e.g., Social Security numbers).
            If you’re sharing a resume for troubleshooting, feel free to redact sensitive details first.
          </p>
        </section>
      </div>
    </div>
  );
}
